











































import { Component, Vue } from "vue-property-decorator";
import Button from "@/components/Button.vue";
import Card from "@/components/Card.vue";
import Spinner from "@/components/Spinner.vue";
import Tag from "@/components/Tag.vue";

@Component({
  components: {
    Button,
    Card,
    Spinner,
    Tag,
  },
})
export default class Detail extends Vue {
  name = "home"
  id = ""
  data() {
    return {
      id: "",
      firstButton: "Print",
      secondButton: "Share",
    }
  }
  get mealDetail() {
    return this.$store.state.mealDetail;
  }
  get tags() {
    return this.$store.state.tags;
  }
  get ingredients() {
    return this.$store.state.ingredients;
  }
  get relevantItems() {
    return this.$store.getters.pickRelevantItems;
  }
  created() {
    // Get a meal ID that has passed into route param and dispatch get detail
    const { id } = this.$route.params;
    this.id = id;
    this.$store.dispatch('getDetail', id);
  }
  print() {
    window.print();
  }
}

